import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useAllEarningsCheckTicker = (
  pageTable: number,
  searchTerm?: string,
  shouldFetchData?: boolean
) => {

  const { isLoading, isError, data, refetch } = useQuery<
    any,
    AxiosError<any>,
    any
  >(
    ["ticker", "status", pageTable, searchTerm],
    async () => {
      const query: Record<string, any> = {
        searchTerm,
      };

      if (!searchTerm) {
        delete query.searchTerm;
      }

      const data = await axiosClient.get<any>(
        `/earningsCall/getAll/checkTicker?${qs.stringify(query)}`
      );

      // console.log("data----", data.data);
      return data.data;
    },
    {
      staleTime: Infinity,
      enabled: shouldFetchData, // Only enable the query when searchTerm is not empty
    }
  );

  return { isLoading, isError, data, refetch };
};